// mock api
import './_apis_';

// i18n
import './locales/i18n';

// highlight
import './utils/highlight';

// scroll bar
import 'simplebar/src/simplebar.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// lightbox
import 'react-image-lightbox/style.css';

// editor
// import 'react-quill/dist/quill.snow.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
// material
import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';
//

// redux
import { store } from './redux/store';
// contexts
import { SettingsProvider } from './contexts/SettingsContext';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
// components
import LoadingScreen from './components/LoadingScreen';

import { AuthProvider } from './contexts/JWTContext';
// import { AddUserProvider } from './contexts/AddUserContext';
// import { AuthProvider } from './contexts/FirebaseContext';
// import { AuthProvider } from './contexts/AwsCognitoContext';
// import { AuthProvider } from './contexts/Auth0Context';

//
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AddUserProvider } from './contexts/AddUserContext';
import { ScoreCardsProvider } from './contexts/ScoreCardsContext';
import { EventsProvider } from './contexts/EventsContext';
import { ReportingProvider } from './contexts/ReportingContext';
import NetworkProvider from './contexts/networkContext';

// ----------------------------------------------------------------------

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => {
      reg.unregister().catch(err => console.warn('SW unregister failed', err));
    });
  }).catch(err => console.warn('Failed to get service worker registrations:', err));
}

ReactDOM.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <BrowserRouter>
        {/* <PersistGate loading={<LoadingScreen />} persistor={persistor}> */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <ReportingProvider>
            <EventsProvider>
              <SettingsProvider>
                <CollapseDrawerProvider>
                  <ScoreCardsProvider>
                    <AddUserProvider>
                      <AuthProvider>
                        <NetworkProvider>
                          <App />
                        </NetworkProvider>
                      </AuthProvider>
                    </AddUserProvider>
                  </ScoreCardsProvider>
                </CollapseDrawerProvider>
              </SettingsProvider>
            </EventsProvider>
          </ReportingProvider>
        </LocalizationProvider>
        {/* </PersistGate> */}
      </BrowserRouter>
    </ReduxProvider>
  </HelmetProvider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
